(function () {
  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $all(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function buildPairsMap() {
    const map = new Map();
    $all('.wp-block-bespoke-theme-edu-content').forEach((el) => {
      const t = (el.getAttribute('data-topic') || '').trim();
      const s = (el.getAttribute('data-subtopic') || '').trim();
      if (!t || !s) return;
      if (!map.has(t)) map.set(t, new Set());
      map.get(t).add(s);
    });
    const obj = {};
    for (const [topic, subs] of map.entries()) {
      obj[topic] = Array.from(subs.values()).sort((a, b) =>
        a.localeCompare(b, undefined, { sensitivity: 'base' })
      );
    }
    return obj;
  }

  function updateVisibility(selected) {
    const { topic, subtopic } = selected;
    const blocks = $all('.wp-block-bespoke-theme-edu-content');
    blocks.forEach((el) => {
      const requiredTopic = el.getAttribute('data-topic') || '';
      const requiredSubtopic = el.getAttribute('data-subtopic') || '';
      const matchMode = el.getAttribute('data-match-mode') || 'both';

      let show = false;
      if (matchMode === 'topic') {
        show = topic === requiredTopic;
      } else if (matchMode === 'subtopic') {
        show = subtopic === requiredSubtopic;
      } else {
        // both
        show = topic === requiredTopic && subtopic === requiredSubtopic;
      }
      el.style.display = show ? '' : 'none';
    });
  }

  function setSubtopicOptions(subSelect, options, selectValue) {
    const desired = selectValue != null ? selectValue : subSelect.value;

    while (subSelect.firstChild) subSelect.removeChild(subSelect.firstChild);
    (options || []).forEach((s) => {
      const opt = document.createElement('option');
      opt.value = s;
      opt.textContent = s;
      subSelect.appendChild(opt);
    });

    const finalValue =
      (desired && options.includes(desired) && desired) || options[0] || '';
    subSelect.value = finalValue;
    return finalValue;
  }

  function initFilter(root) {
    const topicSelect = $('[data-role="topic"]', root);
    const subtopicSelect = $('[data-role="subtopic"]', root);
    if (!topicSelect || !subtopicSelect) return;

    const pairs = buildPairsMap();

    function refreshSubtopicsForTopic(topic) {
      const allowed = pairs[topic] || [];
      const fallback =
        allowed.length > 0
          ? allowed
          : Array.from(subtopicSelect.querySelectorAll('option')).map(
              (o) => o.value
            );

      const newSub = setSubtopicOptions(subtopicSelect, fallback);
      return newSub;
    }

    const initialTopic =
      topicSelect.value ||
      (topicSelect.options[0] && topicSelect.options[0].value) ||
      '';
    const initialSub = refreshSubtopicsForTopic(initialTopic);

    updateVisibility({ topic: initialTopic, subtopic: initialSub });

    topicSelect.addEventListener('change', (e) => {
      const topic = e.target.value;
      const sub = refreshSubtopicsForTopic(topic);
      updateVisibility({ topic, subtopic: sub });

      document.dispatchEvent(
        new CustomEvent('tep:eduFilter:change', {
          detail: { topic, subtopic: sub },
        })
      );
    });

    subtopicSelect.addEventListener('change', (e) => {
      const topic = topicSelect.value;
      const subtopic = e.target.value;
      updateVisibility({ topic, subtopic });

      document.dispatchEvent(
        new CustomEvent('tep:eduFilter:change', {
          detail: { topic, subtopic },
        })
      );
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    const filters = $all('.wp-block-bespoke-theme-edu-filter');
    filters.forEach(initFilter);
  });
})();
